import { ColumnOptionsUtils } from "library/greco-components";
import { atom } from "jotai";
import { ExpandedColumn } from "library/types/columns";

export const offersPageSearchState = atom<string>("");
export const offersPageSkipState = atom<number>(0);
export const offersPageTotalState = atom<number>(0);
export const offersPageTopState = atom<number>(25);
export const offersPageSortState = atom<{ key: string; dir: string }>({
  key: "",
  dir: "",
});
export const offersPageColumnsState = atom<ExpandedColumn[]>([]);
export const offersPageRowsState = atom<any[]>([]);

export const offersPageInvalidateOfferDialogState = atom<{
  isOpen: boolean;
  offer: any | null;
}>({ isOpen: false, offer: null });

// confirmation of marking (markAsError) or unmarking an offer as error entry
export const offersPageMarkOfferAsErrorDialogState = atom<{
  isOpen: boolean;
  offer: any | null;
  markAsError: boolean;
}>({ isOpen: false, offer: null, markAsError: true });

export const areAnyColumnsFilteredState = atom((get) => {
  const columns = get(offersPageColumnsState);
  return columns.some((col) => ColumnOptionsUtils.isColumnFiltered(col.filter));
});
